import {z,y}from'./chunk-ISOGKAQC.mjs';var t=new z(y());t.buildSchema();t.initializeRuntime();var s=t,n=t.getSchema();export{s as a,n as b};